import { render, staticRenderFns } from "./FormPageNotFound.vue?vue&type=template&id=1eb7d95a&scoped=true&"
import script from "./FormPageNotFound.vue?vue&type=script&lang=js&"
export * from "./FormPageNotFound.vue?vue&type=script&lang=js&"
import style0 from "./FormPageNotFound.vue?vue&type=style&index=0&id=1eb7d95a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb7d95a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VAvatar,VCard,VCardText})
